export default function(key) {
  this.selectedProfessions.splice(key, 1);
  if (this.selectedProfessions.length < 5)
  {
    this.showProfessionLimitError = false;
  }
}
